import { inject } from '@angular/core';
import { ShiftSettingApiService } from '@shared/services/shift-setting-api.service';
import { TableConfig, PLACEHOLDER_FUNCTIONS } from '../generic-p-table.interfaces';

export const shiftSettingTableConfig = (): TableConfig => {
  const shiftSettingApiService = inject(ShiftSettingApiService);

  return {
    title: 'Quản lý ca trực',
    entityName: 'ca trực',
    service: shiftSettingApiService,
    method: 'getAll',
    transformResponse: (response: any) => {
      // Transform minutes to hours for display
      if (response && response.data.items) {
        response.data.items = response.data.items.map((item: any) => ({
          ...item,
          fromDisplay: item.from ? Math.floor(item.from / 60) + ':' + String(item.from % 60).padStart(2, '0') : '',
          toDisplay: item.to ? Math.floor(item.to / 60) + ':' + String(item.to % 60).padStart(2, '0') : ''
        }));
      }
      return response;
    },
    columns: [
      { field: 'code', header: 'Mã ca', width: 'min-w-[100px]', sortable: true, type: 'text' },
      { field: 'name', header: 'Tên ca', width: 'min-w-[150px]', sortable: true, type: 'text' },
      { field: 'fromDisplay', header: 'Từ giờ', width: 'min-w-[100px]', sortable: false, type: 'text' },
      { field: 'toDisplay', header: 'Đến giờ', width: 'min-w-[100px]', sortable: false, type: 'text' }
    ],
    actions: [
      {
        location: 'toolbar',
        useDefaultStyle: 'add',
        onClick: PLACEHOLDER_FUNCTIONS.OPEN_NEW
      },
      {
        location: 'row',
        useDefaultStyle: 'edit',
        onClick: PLACEHOLDER_FUNCTIONS.EDIT
      }
    ],
    features: {
      virtualScroll: false,
      toolbar: true,
      selection: {
        mode: 'single',
        dataKey: 'id'
      }
    }
  };
};
